<app-view-uploaded-document [isDocumentViewPage]="true"></app-view-uploaded-document>